import { isValidPhoneNumber } from 'react-phone-number-input';

import { Check, FormValue } from 'lib/utils/formValidation/formValidation';

/*
  React semantics make empty inputs that are controlled components have a value of "".
  Therefore we have to check for both nullish values and the empty string.
  Additionally, we should add empty array, empty object, etc. as needed.

  MOST rules should early exit and NOT FAIL if they receive an empty value.
  This is because failing on an empty value is implicitly treating a field as required.
 */
const isValidPhone: Check = (value: FormValue | null): boolean =>
  value == null || value === '' ? true : isValidPhoneNumber(value);

export default isValidPhone;
